module.exports = __webpack_public_path__ + "img/scroll_selected.96240ebe.svg";